<template>
	<modal :show.sync="syncModal" footerClasses="d-none">
		<form-user-name>
			<template #return>
				<base-button
					@click.stop="syncModal = false"
					:disabled="formProcessing"
					type="white"
					size="md"
					class="form-btn bg-transparent px-0 font-weight-normal shadow-none"
					>Cancel</base-button
				>
			</template>
		</form-user-name>

		<template #footer>
			<div class="sr-only"></div>
		</template>
	</modal>
</template>

<script>
import FormUserName from "@components/FormUserName";

export default {
	name: "modal-user-name",
	inject: ["ErrorService"],
	components: {
		FormUserName,
	},
	data() {
		return {
			syncModal: false,
			formProcessing: false,
		};
	},
	mounted() {
		this.ErrorService.stopProcessingOnFail(this);

		this.$bus.trackEvent("toggle-modal", (payload) => {
			if ("user-name" === payload.key) this.syncModal = payload.active;
		});

		this.$bus.trackEvent("user-name-form-processing", (payload) => {
			this.syncModal = payload;
			this.formProcessing = payload;
		});
	},
};
</script>
